import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "schedule-days__day" }
const _hoisted_2 = ["onKeyup"]
const _hoisted_3 = {
  key: 0,
  class: "icon icon-blocked"
}
const _hoisted_4 = {
  key: 1,
  class: "icon icon-minus"
}
const _hoisted_5 = {
  key: 2,
  class: "icon icon-exercised"
}
const _hoisted_6 = {
  key: 3,
  class: "icon icon-programmed"
}
const _hoisted_7 = {
  key: 4,
  class: "icon icon-read"
}
const _hoisted_8 = {
  key: 5,
  class: "icon icon-write"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-exercised" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-programmed" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-read" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-write" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import { Mutations } from '@/store';
import { formatDateWithDay } from '@/core/filters';
import { ScheduleDay } from '@/models/schedule.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScheduleDay',
  props: {
  day: {
    type: Object as PropType<ScheduleDay>,
    required: true,
  },
},
  emits: ['update'],
  setup(__props, { emit }) {

const props = __props;



const store = useStore();


const score = computed<number>((): number => {
  return props.day.played && !hasGoodActivity(props.day)
    ? -1
    : hasGoodActivity(props.day)
    ? 1
    : 0;
});

const hasActivity = (day: ScheduleDay): boolean => {
  return day.played || hasGoodActivity(day);
};
const hasGoodActivity = (day: ScheduleDay): boolean => {
  return day.programmed || day.exercised || day.read || day.write;
};
const updateDay = (day: ScheduleDay) => {
  // for quick update
  props.day.played === !!props.day.game;
  store.commit(Mutations.UpdateDay, day);
};
const toggleExercised = (day: ScheduleDay) => {
  store.commit(Mutations.ToggleExercised, day);
  update();
};
const toggleProgrammed = (day: ScheduleDay) => {
  store.commit(Mutations.ToggleProgrammed, day);
  update();
};
const toggleWrite = (day: ScheduleDay) => {
  store.commit(Mutations.ToggleWrite, day);
  update();
};
const toggleRead = (day: ScheduleDay) => {
  store.commit(Mutations.ToggleRead, day);
  update();
};
const update = () => {
  emit('update', props.day);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "schedule-days__game-input",
      onKeyup: [
        _cache[0] || (_cache[0] = ($event: any) => (updateDay(__props.day))),
        _withKeys(_withModifiers(update, ["exact","prevent"]), ["enter"])
      ],
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.day.game) = $event))
    }, null, 40, _hoisted_2), [
      [_vModelText, __props.day.game]
    ]),
    _createElementVNode("label", null, _toDisplayString(_unref(formatDateWithDay)(__props.day.date)), 1),
    _createElementVNode("label", {
      class: _normalizeClass(["scheduled_days__score", {
        negative: _unref(score) < 0,
        exercised: __props.day.exercised,
        programmed: __props.day.programmed,
        read: __props.day.read,
        write: __props.day.write,
      }])
    }, [
      (_unref(score) === 0 && !hasActivity(__props.day))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true),
      (_unref(score) < 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4))
        : _createCommentVNode("", true),
      (__props.day.exercised)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
        : _createCommentVNode("", true),
      (__props.day.programmed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6))
        : _createCommentVNode("", true),
      (__props.day.read)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7))
        : _createCommentVNode("", true),
      (__props.day.write)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("label", {
      class: _normalizeClass(["scheduled_days__checkbox--exercised", { active: __props.day.exercised }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleExercised(__props.day)))
    }, _hoisted_10, 2),
    _createElementVNode("label", {
      class: _normalizeClass(["scheduled_days__checkbox--programmed", { active: __props.day.programmed }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleProgrammed(__props.day)))
    }, _hoisted_12, 2),
    _createElementVNode("label", {
      class: _normalizeClass(["scheduled_days__checkbox--read", { active: __props.day.read }]),
      onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleRead(__props.day)))
    }, _hoisted_14, 2),
    _createElementVNode("label", {
      class: _normalizeClass(["scheduled_days__checkbox--write", { active: __props.day.write }]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleWrite(__props.day)))
    }, _hoisted_16, 2)
  ]))
}
}

})